import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AlertDialog, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger, AlertDialogCancel } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { Power, Loader2 } from "lucide-react";
import { toast } from "sonner";
import * as devicesApi from "@/services/devicesApi";

interface UnenrollDeviceProps {
  deviceId: string;
  deviceName: string;
}

const UnenrollDevice = ({ deviceId, deviceName }: UnenrollDeviceProps) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleUnenroll = async () => {
    try {
      setIsDeleting(true);
      await devicesApi.bulkUnenroll({ deviceIds: [deviceId] });
      toast.success(`Device ${deviceName} has been unenrolled`);
    } catch (error) {
      console.error('Error unenrolling device:', error);
      toast.error('Failed to unenroll device');
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <div className="flex items-center cursor-pointer w-full">
          <Power className="mr-2 h-4 w-4" />
          Unenroll Device
        </div>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Unenroll Device</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to unenroll {deviceName}? This action cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <Button variant="destructive" onClick={handleUnenroll} disabled={isDeleting}>
            {isDeleting ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" />Unenrolling...</> : 'Unenroll'}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default UnenrollDevice;
